import { useSetAtom } from "jotai";
import { useEffect, useState } from "react";
import { navbarSuppressionCountAtom } from "web_myplann/Shared/State/navbarSuppressionAtom";
import { device, isAndroidApp } from "web_myplann/Utils/device";

const NAVBAR_HIDE_ACK_FALLBACK_MS = 250;

export const useHideNavbar = (open: boolean): boolean => {
	const [navbarHidden, setNavbarHidden] = useState(false);
	const setNavbarSuppressionCount = useSetAtom(navbarSuppressionCountAtom);

	useEffect(() => {
		if (!open) return;
		let cancelled = false;
		setNavbarSuppressionCount((count) => count + 1);
		const hidden = device.showNavbar(false).catch(() => {});
		Promise.race([
			hidden,
			new Promise((resolve) => {
				setTimeout(resolve, NAVBAR_HIDE_ACK_FALLBACK_MS);
			}),
		]).then(() => {
			if (!cancelled) {
				setNavbarHidden(true);
			}
		});
		return () => {
			cancelled = true;
			setNavbarHidden(false);
			setNavbarSuppressionCount((count) => Math.max(0, count - 1));
		};
	}, [open, setNavbarSuppressionCount]);

	return isAndroidApp ? open && navbarHidden : open;
};
